import React from 'react';

const FeesPanelSkeletonLoader: React.FC = () => {
  return (
    <>
      {/* Table Container Skeleton */}
      <div style={{
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        width: '100%'
      }}>
        {/* Table Header Skeleton */}
        <div style={{
          padding: '16px 20px',
          borderBottom: '1px solid #f3f4f6',
          background: 'linear-gradient(135deg, #fafbfc 0%, #f8fafc 100%)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}></div>
            <div style={{
              width: '150px',
              height: '16px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}></div>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <div style={{
              width: '100px',
              height: '32px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}></div>
            <div style={{
              width: '100px',
              height: '32px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}></div>
          </div>
        </div>

        {/* Table Rows Skeleton */}
        <div style={{ padding: '20px' }}>
          {[...Array(10)].map((_, index) => (
            <div
              key={index}
              style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1.5fr 1.2fr 1.2fr 1fr 1fr 1fr 1.5fr',
                alignItems: 'center',
                gap: '20px',
                padding: '16px',
                borderBottom: index < 9 ? '1px solid #f3f4f6' : 'none',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${index * 0.1}s`
              }}
            >
              {/* Student Info */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '38px',
                  height: '38px',
                  borderRadius: '10px',
                  background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 2s infinite',
                  flexShrink: 0
                }}></div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{
                    width: '80%',
                    height: '14px',
                    borderRadius: '8px',
                    background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 2s infinite',
                    marginBottom: '6px'
                  }}></div>
                  <div style={{
                    width: '50%',
                    height: '12px',
                    borderRadius: '8px',
                    background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 2s infinite'
                  }}></div>
                </div>
              </div>

              {/* Class & Section */}
              <div>
                <div style={{
                  width: '70%',
                  height: '14px',
                  borderRadius: '8px',
                  background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 2s infinite',
                  marginBottom: '6px'
                }}></div>
                <div style={{
                  width: '50%',
                  height: '12px',
                  borderRadius: '8px',
                  background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 2s infinite'
                }}></div>
              </div>

              {/* Receipt No */}
              <div style={{
                width: '85%',
                height: '14px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>

              {/* Paid Date */}
              <div style={{
                width: '90%',
                height: '14px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>

              {/* Amount */}
              <div style={{
                width: '70%',
                height: '14px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>

              {/* Status Badge */}
              <div style={{
                width: '60px',
                height: '26px',
                borderRadius: '20px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>

              {/* Payment Mode */}
              <div style={{
                width: '65%',
                height: '14px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}></div>

              {/* Actions */}
              <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                {[...Array(3)].map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: '34px',
                      height: '34px',
                      borderRadius: '10px',
                      background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                      backgroundSize: '200% 100%',
                      animation: 'shimmer 2s infinite'
                    }}
                  ></div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Skeleton */}
        <div style={{
          background: '#fafbfc',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <div style={{
            width: '80px',
            height: '14px',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 2s infinite'
          }}></div>

          <div style={{ display: 'flex', gap: '6px' }}>
            {[...Array(9)].map((_, i) => (
              <div
                key={i}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 2s infinite'
                }}
              ></div>
            ))}
          </div>

          <div style={{
            width: '80px',
            height: '36px',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 2s infinite'
          }}></div>
        </div>
      </div>

      {/* Animation styles */}
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
};

export default FeesPanelSkeletonLoader;